import Headroom from 'headroom.js';

(function ($, window, document, undefined) {
	$(function () {
		// Topbar
		var header = document.querySelector('.site-header');
		// construct an instance of Headroom, passing the element
		var headroom = new Headroom(header, {
			offset: 205,
			tolerance: 5,
			classes: {
				initial: '',
				pinned: 'site-header--pinned',
				unpinned: 'site-header--unpinned',
				notTop: 'site-header--sticky',
			},
		});
		// initialise
		headroom.init();

		// To top
		$('.js-site-footer__to-top').click(function (e) {
			e.preventDefault();

			try {
				document
					.querySelector('body')
					.scrollIntoView({ behavior: 'smooth', block: 'start' });
			} catch (e) {
				window.scrollTo(0, 0);
			}
		});

		// Filter
		var $filterBtn = $('.js-bx-filter__toggle-btn');
		var $filterSection = $('.bx-filter-section');
		$filterBtn.click(function () {
			$filterSection.toggleClass('bx-filter-section--opened');
			$filterBtn.toggleClass('bx-filter__toggle-btn--opened');
		});

		// Drawer
		var $page = $('.site');
		var $overlay = $('.overlay');
		var $menuDrawer = $('.js-menu-drawer');
		$menuDrawer.drawer({
			onOpen: function () {
				$overlay.addClass('overlay--active').on('click.drawer-overlay', function () {
					$menuDrawer.drawer('close');
				});
				$page.addClass('site--no-scroll');
			},
			onClose: function () {
				$overlay.removeClass('overlay--active').off('click.drawer-overlay');
				$page.removeClass('site--no-scroll');
			},
		});

		$('.js-menu-drawer__open-button').click(function () {
			$menuDrawer.drawer('open');
		});
		document.addEventListener('a11dialog:show', () => {
			$menuDrawer.drawer('close');
		});
	});
})(jQuery, window, document);
